// extracted by mini-css-extract-plugin
export default {"table":"SeachResultsTable_table__8UEdA"};